import {
  BaseReq,
  BaseResp,
  PaginationReq,
  PaginationResp,
  UpdaterResp,
  FileRecord,
} from "@/core/interface";
import { getCurrentUserId } from "@/utils";
//类目明细
export class ListRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  projectFundId: string | undefined = undefined; // 工程款项ID
  budget: number = 0; // 方案预算
  ratio: number = 0; // 占比
  remark: string = ""; // 备注
}
//工程量清单
class QuantityRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0; // 工程量
  price: number = 0; // 综合单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
}

//材料清单
class MaterialRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialBrand: string = ""; // 品牌
  materialModel: string = ""; // 规格型号
  materialUnit: string = ""; // 结算单位
  count: number = 0; // 数量
  price: number = 0; // 单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
  systemName:string="";// 系统名称
}

export class SolutionReq extends BaseReq {
  name:string | undefined = undefined;
  projectId: string | undefined = undefined; // 项目ID
  totalBudget: number = 0; // 项目总预算
  responsibleTenantUserId: string | undefined = getCurrentUserId(); // 方案负责人ID
  remark: string = ""; // 备注
  list: ListRecord[] = []; // 类目明细
  materialList: MaterialRecord[] = []; //材料清单
  quantitiesList: QuantityRecord[] = []; //工程量清单
  fileList: FileRecord[]; //附件
  displayTotalBudget: string = ""; //带千分位的项目总预算
  id: string = "";
}

export class SolutionPageReq extends PaginationReq {
  name: string | undefined = undefined; // 项目名称
  cooperationCompanyId: string | undefined = undefined; // 客户ID
  projectTypeId: string | undefined = undefined; // 项目类型ID
  provinceId: number | undefined = undefined; // 所在地区 - 省ID
  cityId: number | undefined = undefined; // 所在地区 - 市ID
  districtId: number | undefined = undefined; // 所在地区 - 区ID
  responsibleTenantUserId: string | undefined = undefined; // 预算负责人id
  validStatus: string | undefined = undefined; // 项目状态
  flowStatus: string | undefined = undefined; // 审批状态
}

export class SolutionListRecord extends UpdaterResp {
  id: number = 0; // 技术方案ID
  bidNo: string = ""; // 技术方案编号
  projectName: string = ""; // 项目名称
  totalBudget: number = 0; // 方案总预算
  responsibleTenantUserId: string = ""; // 方案负责人ID
  responsibleTenantUserName: string = ""; // 方案负责人姓名
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class SolutionPageResp extends PaginationResp<SolutionListRecord> {}

export class SolutionDetailResp extends UpdaterResp {
  id: string = ""; // 技术方案ID
  bizNo: string = ""; // 技术方案编号
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  totalBudget: number = 0; // 项目总预算
  responsibleTenantUserId: string = ""; // 方案负责人ID
  responsibleTenantUserName: string = ""; // 方案负责人姓名
  remark: string = ""; // 备注
  list: ListRecord[] = []; // 类目明细
  apiList: ListRecord[] = []; // 类目明细
}

// 技术方案选择器
export class SolutionSimplePageReq extends PaginationReq {
  skillSolutionBizNo: string = "";
  projectId: string = "";
  validStatus:string='';
}

export class SolutionSimpleRecord extends UpdaterResp {
  id: number = 0; // 技术方案ID
  bizNo: string = ""; // 技术方案编号
  totalBudget: number = 0; // 方案总预算
  responsibleTenantUserName: string = ""; // 方案负责人姓名
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
}

export class SolutionSimplePageResp extends PaginationResp<SolutionSimpleRecord> {}
